import React, { useState } from 'react';
import { ExportCampaignPerformanceExcel } from '../../../../Services/PerformanceInsights/CampaignInsightsService';
import { showError } from '../../../../Helper';
import { GetApp } from '@material-ui/icons';
import { PerformanceInsightsTranslationPath } from '../i18n/PerformanceInsightsLocale';
import { Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const ExportExcelButton = ({ params ,handler}) => {
  const [isExporting, setIsExporting] = useState(false);
  const { t } = useTranslation(PerformanceInsightsTranslationPath);

  const downloadExcelHandler = async () => {
    setIsExporting(true);
    try {
      await handler(params);
    } catch (error) {
      showError(t('export_campaign_performance_error'));
    } finally {
      setIsExporting(false);
    }
  };
  return (
    <div className='flex fj-end fa-center gap-2 py-3 px-2'>
      <Button
        startIcon={<GetApp />}
        onClick={downloadExcelHandler}
        variant='outlined'
        className='capitalize'
        disabled={isExporting}
      >
        {isExporting ? t('exporting') : t('export_excel')}
      </Button>
    </div>
  );
};
export default ExportExcelButton;
